export const OT_VIEW_JOBS_DIALOG_KEY = 'OT-View-Jobs-Dialog';

export const OT_PAGE_NO_PARAM_NAME = 'pageNo';
export const OT_PAGE_SIZE_PARAM_NAME = 'pageSize';

export const THUMBS_UP_GREEN_COLOR = '#52C41A'; // 'lightgreen';
export const THUMBS_DOWN_RED_COLOR = '#ED5645'; //'#FF6666';
export const THUMBS_UP_ICON_SIZE = 20;
